const AuthenticationService = {
    SELF: 'SELF',
    FPT_ID: 'FPT_ID'
}

const AuthenticationConst = {
    authenticationService: AuthenticationService,
    TOKEN_KEY: 'jwToken'
}

export default AuthenticationConst
